import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import kecko from '../../../assets/kecko.png';

class Calendar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div>
        <Helmet>
          <title>Kalendár</title>
          <meta property="og:description" content="Kalendár" />
          <meta property="og:image" content={kecko} />
        </Helmet>
        {this.props.children}
      </div>
    );
  }
}

Calendar.propTypes = {
  dispatch: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired
};

export default connect(state => {
  return {};
})(Calendar);



// WEBPACK FOOTER //
// ./src/app/container/calendar/calendar.js